import React from "react"

import Container from "../components/Container"
import Skills from "../components/Skills"

export default function About() {
    return (
        <Container>
            <article id="about" className="wrapper">
                <h1>About</h1>

                <article className="intro">
                    <p>
                        I'm a <span>data-oriented</span> Full-stack Software Engineer.
                        With <span>5+ years</span> of experience in software development, I have a strong foundation in developing accessible, responsive, and clean PWAs tailored for SaaS platforms with <span>Typescript</span> and <span>NextJS</span>.
                    </p>
                    <p>Optimizing <span>performance</span> and ensuring <span>scalability</span> of APIs and SQL queries are also my expertise.</p>
                    <p>I'm also a Data Engineering, Cyber Security, AI, and IoT enthusiast.</p>
                    <p>
                        Besides coding, I'm a <span>bookworm</span> and also an <span>artist</span>.
                        I enjoy reading a diverse range of books across various genres and topics.
                        I also love painting and drawing using mixed media, and I play both piano and guitar.
                    </p>
                </article>

                <Skills />
            </article>
        </Container>
    )
}
